import LoginForm from "./LoginForm";
import Logo from "../../assets/invited-logo.svg";
import { NavLink } from "react-router";
import { INVITED_APP_BASE_URL } from "../../common";

export default () => {
  return (
    <div className="bg-[#f9f9f9] min-h-screen flex flex-col items-center">
      <div className="flex items-center justify-between w-full h-[100] border-b-1 border-b-[#dddddd] px-12">
        <a href={INVITED_APP_BASE_URL}>
          <Logo className="h-[28]" />
        </a>
        <NavLink className="text-xl font-semibold text-[#333]" to="/sign-up">
          Sign Up
        </NavLink>
      </div>
      <div className="pt-16">
        <LoginForm />
      </div>
    </div>
  );
};
